import React from "react";
import { useState, useEffect } from "react";
import { BarChart, IGroupedData } from "../Charts/BarChart";
import { BarChartWithXValuesRotate } from "../Charts/BarChartWithXValuesRotate";
import { PieChart } from "../Charts/PieChart";
import axiosAuth from "../Axios/Interceptors";
import AppContext from "../Context/Context";
import DragDrop from "../DragDrop/DragDrop";

export function Dragdroptest() {
  //Dragdrop starts

  const [dragDropFeatures, setDragDropFeatures] = useState({
    ObjectID: 0,
    ObjectType: AppContext.FileUploadObjectTypeReInvestmentFile,
    MaxAllowedFiles: 10,
    UploadType: 1,
    FolderName: "Test",
    PTUploadedFiles: [
      {
        Name: "jlr-BwQKKMo-oRTvYHf5F6YCUrUeFvfo-e51afa01-bb88-4ca8-826a-6c1bde772ccd_Ad12.png",
        FileURL:
          "Test/jlr-BwQKKMo-oRTvYHf5F6YCUrUeFvfo-e51afa01-bb88-4ca8-826a-6c1bde772ccd_Ad12.png",
        FilePathFull:
          "https://files.pfibusinesstools.com/filesjlr/jlr-BwQKKMo-oRTvYHf5F6YCUrUeFvfo-e51afa01-bb88-4ca8-826a-6c1bde772ccd/Ad12.png",
        SysObjID: 4550,
        ObjectID: 0,
        FileURLDisplay:
          "https://files.pfibusinesstools.com/filesjlr/jlr-BwQKKMo-oRTvYHf5F6YCUrUeFvfo-e51afa01-bb88-4ca8-826a-6c1bde772ccd/Ad12.png",
        AlreadyUploaded: true,
      },
      {
        Name: "jlr-BwQKKMo-7lT2YefiFGYRUGU6TAg0-88c721a4-799c-4827-8877-43a5e113fbf1_test.xlsx",
        FileURL:
          "Test/jlr-BwQKKMo-7lT2YefiFGYRUGU6TAg0-88c721a4-799c-4827-8877-43a5e113fbf1_test.xlsx",
        FilePathFull:
          "https://files.pfibusinesstools.com/filesjlr/jlr-BwQKKMo-7lT2YefiFGYRUGU6TAg0-88c721a4-799c-4827-8877-43a5e113fbf1/test.xlsx",
        SysObjID: 4551,
        ObjectID: 0,
        FileURLDisplay: "/DragDropIcons/xls_icon.png",
        AlreadyUploaded: false,
      },
      {
        Name: "jlr-BwQKKMo-7lT2YefiFGYRUGU6TAg0-88c721a4-799c-4827-8877-43a5e113fbf1_test.xlsx",
        FileURL:
          "Test/jlr-BwQKKMo-7lT2YefiFGYRUGU6TAg0-88c721a4-799c-4827-8877-43a5e113fbf1_test.xlsx",
        FilePathFull:
          "https://files.pfibusinesstools.com/filesjlr/jlr-BwQKKMo-7lT2YefiFGYRUGU6TAg0-88c721a4-799c-4827-8877-43a5e113fbf1/test.xlsx",
        SysObjID: 4551,
        ObjectID: 0,
        FileURLDisplay: "/DragDropIcons/xls_icon.png",
        AlreadyUploaded: false,
      },
    ],
  });

  const [uploadFileList, setUploadFileList] = useState<any>([]);
  const [triggerChild, setTriggerChild] = useState(false);

  function handleDragDropCallback(ChildData: any) {
    debugger;
    setUploadFileList(ChildData);
  }

  function SaveFiles(ObjectType: number, ObjectID: number) {
    debugger;
    let uploadFileListArray = [];
    for (let index = 0; index < uploadFileList.length; index++) {
      if (!uploadFileList[index].AlreadyUploaded) {
        uploadFileListArray.push(uploadFileList[index]);
      }
    }

    if (uploadFileListArray && uploadFileListArray.length > 0) {
      let object = {} as any;
      object.typeid = 1;
      object.attachmenttype = ObjectType;
      object.objectid = ObjectID;
      object.applicationid = AppContext.App;
      object.filesdata = uploadFileListArray;
      axiosAuth
        .post(
          AppContext.FileManegmentAPI + "api/PTAttachment/SaveFilesData",
          object
        )
        .then((response) => {
          if (response.data.Status === 1) {
            setTriggerChild(!triggerChild);
            let l_response = response.data.Data;
            let uploadFileArray = [];
            for (let index = 0; index < uploadFileList.length; index++) {
              if (uploadFileList[index].AlreadyUploaded) {
                uploadFileArray.push(uploadFileList[index]);
              }
            }
            for (let index = 0; index < l_response.length; index++) {
              uploadFileArray.push(l_response[index]);
            }

            savedata(uploadFileArray);
          } else {
            console.log("error", response.data.Message);
          }
          //setShowAnimation(false);
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    } else {
      savedata(uploadFileList);
    }
  }
  //Dragdrop ends

  function savemydata() {
    if (uploadFileList && uploadFileList.length > 0) SaveFiles(1, 1);
    else savedata([]);
  }

  function savedata(data: any) {}

  function rebindFiles(id: number) {
    let attachments = [] as any;

    // attachments.push({
    //   ObjectID: gridData[3][i].ObjectID,
    //   Name: gridData[3][i].Name,
    //   FileURLDisplay: AppContext.GetFileIconToDisplay(
    //     gridData[3][i].FileURLRaw
    //   ),
    //   FileURL: gridData[3][i].FileURLRaw,
    //   AlreadyUploaded: true,
    //   S3Path: gridData[3][i].S3Path,
    //   Identifier: gridData[3][i].Identifier,
    //   Title: gridData[3][i].Title,
    //   Tags: gridData[3][i].Tags,
    // });

    setDragDropFeatures((prevState: any) => ({
      ...prevState,
      PTUploadedFiles: attachments,
    }));
  }

  return (
    <div>
      <div>Dragdroptest</div>
      <div className="form-item">
        <span>Attachments:</span>
        <div className="flex-items supp-doc inv-doc">
          <div className="order-drag">
            <DragDrop
              ParentFeatures={dragDropFeatures}
              DragDropCallback={handleDragDropCallback}
              TriggerChild={triggerChild}
            />
            <a onClick={() => savemydata()}>save</a>
          </div>
        </div>
      </div>
    </div>
  );
}
